import React, { useEffect } from "react";
import LinearProgress, { LinearProgressProps } from "@mui/material/LinearProgress";
import { Box, Button, Tooltip, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { SubscriptionType } from "../types/StandardFilesTranslateTypes";
import { AppDispatch, RootState } from "../store/store";
import { generateGetSubscriptionDataAction, generateSubscriptionBuyAction, generateSubscriptionCancelAction, getSubscriptionState } from "../reducers/subscription.slice";
import { connect } from "react-redux";
import { ProgressBar } from "react-bootstrap";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Link } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import LoadingScreen from "./LoadingScreen";
import variable from "../styles/var.module.scss";

interface SubscriptionProps {
  subscription: SubscriptionType;

  onSubscriptionClick?(): void;

  fetchSubscriptionData(): void;

  onSubscriptionCancelClick(): void;
}

const mapStateToProps = (state: RootState) => {
  return {
    subscription: getSubscriptionState(state),
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    onSubscriptionClick: () => dispatch(generateSubscriptionBuyAction()),
    fetchSubscriptionData: () => dispatch(generateGetSubscriptionDataAction()),
    onSubscriptionCancelClick: () => dispatch(generateSubscriptionCancelAction()),
  };
};

const Subscription: React.FC<SubscriptionProps> = (props: SubscriptionProps) => {
  useEffect(() => {
    if (!props.subscription.dataLoaded) {
      props.fetchSubscriptionData();
    }
  });

  const handleSubscriptionBtnClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (e.currentTarget.innerText == "CANCEL") {
      props.onSubscriptionCancelClick();
    }

    //OLD Hard-Coded plan subsciption way - CAN be Removed after Final Consent
    if (e.currentTarget.innerText == "SUBSCRIBE") {
      props.onSubscriptionClick!();
    }

    if (e.currentTarget.innerText == "CHANGE SUBSCRIPTION") {
      window.location.href = 'Pricing';
    }

  };

  return (
    <div className="p-6 max-w-screen-2xl h-full mt-5 mx-auto rounded-xl shadow-lg items-center space-x-4 subscription xl:h-full xl:scale-80 2xl:scale-100">
      {props.subscription.dataLoaded ? (
        <>
          <div className="flex flex-row align-baseline items-center ml-5">
            <Link to={"/"}>
              <ArrowBackIosIcon color="info" />
            </Link>
            <span className={`font-bold 2xl:text-5xl xl:text-3xl`}>Subscription</span>
          </div>
          <div className="flex flex-row  subscription-state 2xl:h-1/6 xl:h-2/6">
            <div className="px-4 flex flex-row basis-9/12 card rounded-lg mx-1 my-2 mt-3 justify-between items-center">
              {props.subscription.isActive ? (
                <div className="flex flex-row justify-between w-full">
                  <h5 className="font-bold">
                    <CheckCircleIcon color={"success"} className={"mr-1"} />
                    Active
                  </h5>
                  <h5>
                    Subscription: <span className="font-bold">{props.subscription.subData.subscriptionName}</span>
                  </h5>
                  <h5>
                    {props.subscription.subData.canceled ? "Valid to" : "Renew at"}: <span className="font-bold">{new Date(props.subscription!.subData!.validTo!).toLocaleDateString()}</span>
                  </h5>
                </div>
              ) : (
                <h5>
                  <CheckCircleOutlineIcon color={"disabled"} className={"mr-1"} />
                  Membership not active
                </h5>
              )}
            </div>
            <div className="basis-4/12 card rounded-lg my-2 mt-3 flex justify-center items-center">
              <Button
                disabled={props.subscription.isActive && props.subscription.subData.canceled}
                color={"primary"}
                variant={"contained"}
                className="text-white"
                onClick={(e: React.MouseEvent<HTMLButtonElement>) => handleSubscriptionBtnClick(e)}
                sx={{ borderRadius: "20px" }}
              >
                {props.subscription.isActive ? "Cancel" : "Change Subscription"}
              </Button>
            </div>
          </div>
          <div className="flex flex-row 2xl:h-3/6 xl:h-3/6 lg:h-3/6 md:h-3/6 subscription-allowance">
            <div className=" px-4 basis-full card rounded-lg mx-1 my-2 mt-3">
              <h5 className="mt-4">
                {props.subscription.isActive ? (
                  <h5>
                    {" "}
                    Allowance{" "}
                  </h5>
                ) : (
                  <h5>
                    {" "}
                    Free allowance{" "}
                  </h5>
                )}
              </h5>
              <div className="basis-12/12 mt-4">
                <span>
                  Pdf pages: {props.subscription.subData.pdfPagesAvailable}/{props.subscription.subData.pdfPagesTotal}
                </span>
                <ProgressBar animated={false} variant="success" now={props.subscription.subData.pdfPagesAvailablePercent} label={props.subscription.subData.pdfPagesAvailablePercent + "%"} />
              </div>
              <div className="basis-12/12 mt-4">
                <span>
                  File words: {props.subscription.subData.wordsAvailable}/{props.subscription.subData.wordsTotal}
                </span>
                <ProgressBar animated={false} variant="success" now={props.subscription.subData.wordsAvailablePercent} label={props.subscription.subData.wordsAvailablePercent + "%"} />
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <LoadingScreen />
        </>
      )}
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Subscription);
